import { z } from 'zod';
export const RunStatusSchema = z.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']);
export const FINISHED_RUN_STATUSES = ['succeeded', 'failed', 'cancelled'];
export const MediaKindSchema = z.enum(['image', 'video']);
export const RunImageSchema = z.object({ index: z.number().int(), nodeId: z.string(), filename: z.string(), url: z.string(), kind: MediaKindSchema });
export const RunSchema = z.object({
    id: z.string(),
    recipeId: z.string().nullable(),
    recipeVersion: z.number().int(),
    machineId: z.string().nullable(),
    status: RunStatusSchema,
    error: z.string().nullable(),
    images: z.array(RunImageSchema),
    createdAt: z.string(),
    finishedAt: z.string().nullable(),
});
/** `overrides`: { "<node id>": { "<input>": value } } — applied to the version for this run only. */
export const StartRunRequestSchema = z.object({
    machineId: z.string().min(1).max(64).optional(),
    version: z.number().int().min(1).optional(),
    overrides: z.record(z.string().min(1).max(32), z.record(z.string().min(1).max(100), z.unknown())).optional(),
    randomizeSeed: z.boolean().optional(),
});
export const RunResponseSchema = z.object({ run: RunSchema });
export const RunsResponseSchema = z.object({ runs: z.array(RunSchema) });
export const MAX_BATCH_IMAGES = 50;
/** One recipe over several input pictures, same settings and seed (doc 39). */
export const StartBatchRequestSchema = z.object({
    images: z.array(z.string().min(1).max(300)).min(1, 'Choose at least one picture').max(MAX_BATCH_IMAGES),
    /** The LoadImage node to swap; needed only when the recipe has several. */
    inputNodeId: z.string().min(1).max(32).optional(),
    machineId: z.string().min(1).max(64).optional(),
    version: z.number().int().min(1).optional(),
    overrides: z.record(z.string().min(1).max(32), z.record(z.string().min(1).max(100), z.unknown())).optional(),
});
export const BatchSchema = z.object({
    id: z.string(),
    recipeId: z.string().nullable(),
    inputNodeId: z.string(),
    createdAt: z.string(),
    /** Every run has finished (succeeded, failed or cancelled). */
    done: z.boolean(),
    items: z.array(z.object({ image: z.string(), run: RunSchema })),
});
export const BatchResponseSchema = z.object({ batch: BatchSchema });
//# sourceMappingURL=runs.js.map